import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AgeVerificationComponent } from './components/age-verification/age-verification.component';

const routes: Routes = [
  {
    component: AgeVerificationComponent,
    path: '',
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class AgeVerificationRoutingModule {}
